export default "__VITE_ASSET__DXXIW5n6__"